import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FullscreenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fullscreen"}/>
}
